module.exports = __webpack_public_path__ + "img/14.0ee74521.jpg";